var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "24px",
    viewBox: "0 0 34 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AB3ECBD4-EFBA-4600-8FAD-63540A2B8788") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    transform: "translate(-370.000000, -1086.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "american-express",
    transform: "translate(370.000000, 1086.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,20.8 C34,22.5672 32.5501429,24 30.7619048,24 L3.23809524,24 C1.44985714,24 0,22.5672 0,20.8 L0,3.2 C0,1.4328 1.44985714,0 3.23809524,0 L30.7619048,0 C32.5501429,0 34,1.4328 34,3.2 L34,20.8 Z",
    id: "Path",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.587381,8.8 L17.8095238,8.8 L17.8095238,14.3848 L16.4155238,14.3848 L16.4155238,10.3088 L14.5123333,14.3848 L13.2470476,14.3848 L11.3859524,10.2368 L11.3859524,14.3848 L8.58095238,14.3848 L8.02885714,13.1384 L5.25057143,13.1384 L4.70738095,14.3848 L3.23809524,14.3848 L5.72090476,8.8 L7.5617619,8.8 L9.9927619,14.1808 L9.9927619,8.8 L12.1744286,8.8 L13.8768571,12.5464 L15.587381,8.8 Z M5.77595238,11.932 L7.46947619,11.932 L6.60652381,9.98 L5.77595238,11.932 Z M28.238619,11.5304 L30.7432857,14.4 L28.9542381,14.4 L27.3028095,12.5368 L25.6092857,14.3856 L20.2380952,14.3856 L20.2380952,8.8 L25.7914286,8.8 L27.353,10.5456 L28.9671905,8.8144 L30.7619048,8.8144 L28.238619,11.5304 Z M24.8750476,13.2128 L26.4260952,11.5304 L25.0555714,10.0128 L21.6280476,10.0032 L21.6280476,11.0496 L24.735,11.0496 L24.735,12.108 L21.6280476,12.108 L21.6280476,13.2128 L24.8750476,13.2128 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american_express.3abff1e97d2f77e7dae7d8e354dc7d4a.svg";
export { ForwardRef as ReactComponent };